import React, { Component } from "react"
import { connect } from "react-redux";

import {  NewPassword } from "../../services/common/action";
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { NavLink } from "react-router-dom";
import validator from "validator";
import Loader from "react-loader-spinner";
import ThanksModel from "./Model/thanksModel";

 
class CreateNewPassword extends Component {
    constructor(props) {
 
        super(props)
        this.state = {
             newPassword:"",
            confirmPassword:"",
            tempPassword : "",
            errors: {
                oldPassword: "",
                newPassword:"",
                confirmPassword:"",
             },
            newPasswordValid: false,
            confirmPasswordValid :false,
             formValid: false,
             openPopUp:false
        };
    }


    handleChange = (e) => {
        e.preventDefault();
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value }, () => {
            this.validateField(name, value);
        });
    };

    validateField(fieldName, value) {
        const {
        errors,
        newPassword,
        confirmPassword,
        newPasswordValid,
        confirmPasswordValid,
         } = this.state;

      let fieldValidationErrors = errors;
      let newPasswordvalid = newPasswordValid;
      let confirmPasswordvalid = confirmPasswordValid;
 
 
        switch (fieldName) {
                case "newPassword":
                newPasswordvalid =
                  value.length >= 8 &&
                  value.match(
                    /(?=.*[_!@#$%^&*-])(?=.*\d)(?!.*[.\n])(?=.*[a-z])(?=.*[A-Z])^.{8,}$/
                  );
                fieldValidationErrors.newPassword = newPasswordvalid
                  ? ""
                  : "Must contain at least one uppercase letter, one lowercase letter, one number, one special character and a minimum of 8 characters";
                break;
                case "confirmPassword":
                confirmPasswordvalid = validator.equals(value, newPassword);
                fieldValidationErrors.confirmPassword = confirmPasswordvalid
                  ? ""
                  : "Password does not match";
                break;
    
              default:
                break;
            }
            if (fieldName === "newPassword") {
                if (confirmPassword !== "") {
                  if (value !== confirmPassword) {
                    fieldValidationErrors.confirmPassword = "Password does not match.";
                  } else {
                    fieldValidationErrors.confirmPassword = "";
                  }
                }
              } else if (fieldName === "confirmPassword") {
                if (value !== newPassword) {
                  fieldValidationErrors.confirmPassword = "Password does not match.";
                } else {
                  fieldValidationErrors.confirmPassword = "";
                }
              }
         
        
        this.setState({ 
            errors: fieldValidationErrors ,
            newPasswordValid: newPasswordvalid,
            confirmPasswordValid : confirmPasswordvalid,    
        }, 
        this.validateForm);
    }

    validateForm() {
        const { newPasswordValid, confirmPasswordValid } = this.state;
        this.setState({ formValid:newPasswordValid && confirmPasswordValid });
    }

    handleLogin = (e) => {
        e.preventDefault();
        const { newPassword, confirmPassword, tempPassword } = this.state;
        let username = this.props.forgotPasswordDetails

        var payLoad = {
            username,
            oldPassword: tempPassword,
            newPassword,
            confirmPassword
        };
  
        this.props.NewPassword(payLoad);
   }
   confirmOkay = () =>{
   this.props.history.push("/login");                                
 
   }
 
   

  componentWillReceiveProps(nextProps){

    if (nextProps.newPassStatus) {
            this.setState({
                openPopUp : true
            })
    }  
  };



    render() {
        const { newPassword, confirmPassword, errors,tempPassword, formValid } = this.state;
      
        const { isLoading } = this.props;

        return (
            <>
             {isLoading && (
                    <div className="pop-mod">
                        <div className="loder-back">
                            <Loader
                                type="Ball-Triangle"
                                color="#CC6900"
                                height="100"
                                width="100"
                            />
                        </div>
                    </div>
                )}

                  <ToastContainer hideProgressBar autoClose={3000} /> 
               
                 <div className="login-wrapper2">
                 <div className="login-sec">
                <div className="login-box">
                    <form onSubmit={this.handleLogin}>
                    <h1>Create New Password</h1>
                  <div className="row input-section" >
                   
                                <div className="form-group">
                                        <input type="password" onChange={this.handleChange}
                                            name="tempPassword" value={tempPassword} placeholder="Temporary Password" />
                                         <div className="input-icon">
                                            <img alt="" src="images/lock.png" />
                                        </div>
                                        <span className="error">This value is required</span>
                                     </div>
                                    <div className="form-group">
                                        <input type="password" onChange={this.handleChange}
                                            name="newPassword" value={newPassword} placeholder="New Password" />
                                        <div className="input-icon">
                                            <img alt="" src="images/lock.png" />
                                        </div>
                                        <span className="error">This value is required</span>
                                        <div style={{ color: "red" }}>{errors.newPassword}</div>
                                    </div>

                                    <div className="form-group">
                                        <input type="password" onChange={this.handleChange}
                                            name="confirmPassword" value={confirmPassword} placeholder="Confirm Password" />
                                         <div className="input-icon">
                                            <img alt="" src="images/lock.png" />
                                        </div>
                                        <span className="error">This value is required</span>
                                       
                                        <div style={{ color: "red" }}>{errors.confirmPassword}</div>
                                    </div>

                                    <div className="form-group">
                        <div className="login-btn">
                            <button type="button" disabled= {!formValid} onClick={this.handleLogin}>Submit</button>
                        </div>
                    </div>
 
                                
                      
                    
                  
                    
                    <div className="form-group">
                        <div className="agree-site-rule">
                            
                            <NavLink to="/login" >
                                            Back To Login
                            </NavLink>
                        </div>
                     </div>
                  </div>
                  </form>
                </div>
                <div className="footer-login">
                        <ul>
                        <li> <a href="https://ferndaleroad.com/about-us/"> About us</a></li>
                                    <li><NavLink to="/Contact" > Contact and Support</NavLink></li>
                                  
                                    <li><NavLink to="/PrivacyPage">Privacy Policy</NavLink></li>
                        </ul>
                    </div> 
           
                
            </div>
 

                </div>
                <ThanksModel   text="Your New password is Created Successfully, Click okay to login" status={this.state.openPopUp}  confirmOkay={this.confirmOkay} />
            </>
        )
    }
}
const mapStateToProps = state => ({
    newPassStatus: state.commonReducer.newPassStatus,
    forgotPasswordDetails : state.commonReducer.forgotPasswordDetails,
    message: state.commonReducer.message,
    loginDetails: state.commonReducer.loginDetails,
    isLoading: state.commonReducer.isLoading



});

const mapDispatchToProps = dispatch => ({
    NewPassword: payLoad => dispatch(NewPassword(payLoad))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateNewPassword);
 